import React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import {
  InputsSubscribe,
  LoginModalSubscribeForm,
} from './form/LoginModalSubscribeForm'
import { LoginModalSubscribeProps } from '../login.types'
import { LoginModalSplittedContainer } from '../login-modal-splitted-container/LoginModalSplittedContainer'
import { Mixpanel } from '../../../../utils/Mixpanel'
import { pushToGTM } from '../../../../utils/pushToGTM'

const LoginModalSubscribe = ({
  modalType,
  setModalType,
  helperText,
  ...props
}: LoginModalSubscribeProps) => {
  const { onSubscribe, isLoading, email = '', leftContent } = props

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<InputsSubscribe>({
    defaultValues: { firstname: '', lastname: '', email, password: '' },
    mode: 'onChange',
  })

  const onSubmit: SubmitHandler<InputsSubscribe> = async ({
    email,
    password,
    firstname,
    lastname,
  }) => {
    onSubscribe({ email, password, firstname, lastname })

    pushToGTM({
      event: 'signup_init',
      firstname,
      lastname,
      email,
    })

    pushToGTM({
      event: 'subscribe',
      'register-form-firstname': firstname,
      'register-form-lastname': lastname,
      'register-form-email': email,
    })

    Mixpanel.identify(email)
    Mixpanel.alias(email)
    Mixpanel.people.set({
      $first_name: firstname,
      $last_name: lastname,
      $email: email,
    })
  }

  return (
    <LoginModalSplittedContainer
      content={{
        left: leftContent ?? null,
        right: (
          <>
            <LoginModalSubscribeForm
              control={control}
              isFormValid={isValid}
              handleOnSubmit={handleSubmit(onSubmit)}
              helperText={helperText}
              {...props}
              setModalType={setModalType}
            />
          </>
        ),
      }}
      isLoading={isLoading}
      modalType={modalType}
      setModalType={setModalType}
    />
  )
}

export default LoginModalSubscribe
